import { registerActivity } from "../registry";
import { WorkflowActivityDefinition } from "../types";

export const DelayUnits = ['minutes', 'hours', 'days'] as const;
export type DelayUnit = typeof DelayUnits[number];

export const Delay: WorkflowActivityDefinition = {
  group: 'internal',
  name: 'delay',
  type: 'activity',
  isFlowControl: true,
  schema: {
    type: 'object',
    properties: {
      duration: {
        title: 'Duration',
        type: 'number',
        default: 20,
        minimum: 1,
      },
      unit: {
        title: 'Unit',
        type: 'string',
        default: 'minutes',
        anyOf: [
          {
            title: 'Minutes',
            type: 'string',
            enum: ['minutes'],
          },
          {
            title: 'Hours',
            type: 'string',
            enum: ['hours'],
          },
          {
            title: 'Days',
            type: 'string',
            enum: ['days'],
          },
        ],
      },
    },
    required: ['duration', 'unit'],
  },
  defaults: {
    duration: 20,
    unit: 'minutes',
  },
  inputs: [
    {
      name: 'inFlow',
      type: 'flowControl',
    },
    {
      name: 'duration',
      type: 'number',
    },
    {
      name: 'unit',
      type: 'text',
      choices: DelayUnits,
    }
  ],
  outputs: [
    {
      name: 'outFlow',
      type: 'flowControl',
    },
  ],
};

registerActivity(Delay);
